import {makeTopic} from "../../topic/topic";

export function makeFilterResultTopic(observers) {
    const topic = makeTopic({
        results: [],
    }, observers)

    return {
        set(results) {
            topic.setState({...topic.getState(), results})
        },
        getState() {
           return topic.getState()
        }
    }
}

function groupByKey(list, key) {
    return list.reduce((hash, obj) => ({...hash, [obj[key]]:( hash[obj[key]] || [] ).concat(obj)}), {})
}

export function makeFilterResultHtml(results) {
    const getTitle = (entry) => entry["highlighted-title"] ? entry["highlighted-title"] : entry.title
    const getMonthDay = (entry) => Number(entry.number) % 2 === 0 ? 15 : 1
    const grouped = groupByKey(results, "year")
    const groupedKeys = Object.keys(grouped)
    const href = window.location.href

    return groupedKeys.reverse().map(gk => {
        return `<div>
                   <div class="catalogues-year">${gk}</div>
                   <div class="catalogues-magazine-section">
                   ${grouped[gk].map(m => `<div class="results-catalogues-month">
                                                           <div>${m.month}</div>
                                                           <div>${getMonthDay(m)}</div>
                                                      </div>
                                                      <div class="catalogues-magazines">
                                                           <div class="">${m.number}</div>
                                                           <div class="catalogues-magazine-title">
                                                               <a href="${href}/${gk}/${m.number}">${getTitle(m)}</a>
                                                           </div>
                                                      </div>`).join("")}
               </div></div>`
    }).join("")
}

